import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';

/**
 * LoadError — the one "we couldn't load X · Try again" card. Standardizes the
 * copy and the amber recovery CTA, replacing the ~6 hand-rolled retry blocks
 * (discover__retry, dash-load-error, acct-load-error, signup-nav-error, wizard__retry…).
 */
@Component({
  selector: 'bodyanalytics-load-error',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './load-error.component.html',
  styleUrls: ['./load-error.component.scss'],
})
export class LoadErrorComponent {
  heading = input("We couldn't load this");
  message = input('Please try again shortly.');
  retryLabel = input('Try again');
  retry = output<void>();
}
